import React from 'react';
// Subcontractor Management:
import SubcontractorLoginComponent from '../SubcontractorManagement/SubcontractorLogin/SubcontractorLogin.component';
import SubcontractorManagementHome from '../SubcontractorManagement/SubcontractorHome/SubcontractorHome.component';

export const subcontractorRoutes = [
  { path: '', element: <SubcontractorManagementHome /> },
  { path: 'login', element: <SubcontractorLoginComponent /> },
];
